import React, { useMemo } from "react";

import { IndexWithRouter } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/CrudTemplate";
import { useSelector } from "react-redux";
import Config from "./config";
import { selectorSettings } from "../../common1/firebase-selectors/settings";

function Main() {
  const { amIAdmin, amITrainer } = useSelector(selectorSettings);
  const a = useMemo(() => Config(amIAdmin), [amIAdmin]);
  if (!amIAdmin && !amITrainer) {
    return <div>You do not have access to this page.</div>;
  }
  return <IndexWithRouter key={amIAdmin ? "1" : "0"} Config={a} />;
}

export default React.memo(Main);
